import React from 'react';
import InfoMessage from 'chameleon/ui-stack/ui/basic/info-message';

export const secureBrowserLink = (
  <a
    tabIndex="0"
    href="https://apclassroom.collegeboard.org/lockdown"
    target="_blank"
    rel="noopener noreferrer"
  >
    LockDown Browser
  </a>
);

export const assignAdminCoordAlert = (
  isResourceForm,
  isPPC,
  disablePpcAutoAssignFlag = false,
) =>
  isResourceForm ? (
    <InfoMessage>
      Teachers select 1 or more classes and any of the following options to
      assign videos.
    </InfoMessage>
  ) : isPPC && !disablePpcAutoAssignFlag ? (
    <InfoMessage>
      Teachers select 1 or more classes and any of the following options to
      assign assessments. Students see Progress Checks as locked until the
      teacher decides they should have access.
    </InfoMessage>
  ) : (
    <InfoMessage>
      Teachers select 1 or more classes and any of the following options to
      assign assessments.
    </InfoMessage>
  );
